"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientRestriction = void 0;
const enums_1 = require("../enums");
exports.ClientRestriction = {
    of(spec) {
        var _a;
        const { SpecValueType } = spec;
        // 只取第一个，前端不会生成多个
        const [backendRestriction] = spec.ValueRestrictionList || [];
        if (!((_a = backendRestriction === null || backendRestriction === void 0 ? void 0 : backendRestriction.RestrictionRuleList) === null || _a === void 0 ? void 0 : _a.length)) {
            throw new Error('无效的值域 (Empty ValueRestrictions)');
        }
        switch (backendRestriction.RestrictionType) {
            case enums_1.RestrictionEnum.Choice: {
                // 这里判断一下SpecValueType，因为有可能存下来的RestrictionRuleList当中，数据类型不匹配
                const isNumeric = [
                    enums_1.ValueTypeEnum.Decimal,
                    enums_1.ValueTypeEnum.Int,
                    enums_1.ValueTypeEnum.DecimalArray,
                    enums_1.ValueTypeEnum.IntArray,
                ].includes(SpecValueType);
                return {
                    type: enums_1.RestrictionEnum.Choice,
                    choices: backendRestriction.RestrictionRuleList.map(x => ({
                        value: isNumeric ? Number(x.Value) : x.Value,
                        valueName: x.ValueName,
                    })),
                };
            }
            case enums_1.RestrictionEnum.Range: {
                const [backendRange] = backendRestriction.RestrictionRuleList;
                return {
                    type: enums_1.RestrictionEnum.Range,
                    range: {
                        min: backendRange.Min,
                        max: backendRange.Max,
                        step: backendRange.Step,
                    },
                };
            }
            case enums_1.RestrictionEnum.Regex: {
                const [backendRegex] = backendRestriction.RestrictionRuleList;
                return {
                    type: enums_1.RestrictionEnum.Regex,
                    regexp: backendRegex.Regex,
                };
            }
            case enums_1.RestrictionEnum.Ref: {
                const [backendRef, anotherBackendRef] = backendRestriction.RestrictionRuleList;
                if (anotherBackendRef) {
                    // 超过一个，是引用了多个 Spu
                    return {
                        type: enums_1.RestrictionEnum.Ref,
                        refs: backendRestriction.RestrictionRuleList.map(x => x.SpuCode),
                    };
                }
                return {
                    type: enums_1.RestrictionEnum.Ref,
                    ref: backendRef.SpuCode,
                };
            }
        }
    },
    isChoice(cr) {
        return cr.type === enums_1.RestrictionEnum.Choice;
    },
    isRange(cr) {
        return cr.type === enums_1.RestrictionEnum.Range;
    },
    isRegex(cr) {
        return cr.type === enums_1.RestrictionEnum.Regex;
    },
    isRef(cr) {
        return cr.type === enums_1.RestrictionEnum.Ref && 'ref' in cr;
    },
    isRefs(cr) {
        return cr.type === enums_1.RestrictionEnum.Ref && 'refs' in cr;
    },
    toBackendRestrictions(cr) {
        const br = {
            RestrictionType: cr.type,
            RestrictionRuleList: [],
        };
        switch (cr.type) {
            case enums_1.RestrictionEnum.Choice: {
                br.RestrictionRuleList = cr.choices.map(x => ({
                    Value: x.value,
                    ValueName: x.valueName,
                }));
                break;
            }
            case enums_1.RestrictionEnum.Range: {
                const { min, max, step } = cr.range;
                br.RestrictionRuleList = [{ Min: min, Max: max, Step: step }];
                break;
            }
            case enums_1.RestrictionEnum.Regex: {
                br.RestrictionRuleList = [{ Regex: cr.regexp }];
                break;
            }
            case enums_1.RestrictionEnum.Ref: {
                const refs = 'refs' in cr ? cr.refs : [cr.ref];
                br.RestrictionRuleList = refs.map(ref => ({ SpuCode: ref }));
                break;
            }
        }
        return {
            ValueRestrictionList: [br],
        };
    },
};
